import React from 'react';
import { Container, Row, Col, Badge } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';

const SobreNosotros = () => {
  return (
    <>
      <Helmet>
        <title>Sobre Nosotros | Lumière Tica</title>

        <meta
          name="description"
          content="Conoce la historia de Lumière Tica y nuestra pasión por crear velas aromáticas y wax melts artesanales con cera de soya y fragancias cuidadosamente seleccionadas."
        />

        <link
          rel="canonical"
          href="https://lumieretica.com/sobre-nosotros"
        />

        <meta
          property="og:title"
          content="Sobre Nosotros | Lumière Tica"
        />

        <meta
          property="og:description"
          content="Conoce la historia de Lumière Tica y nuestra pasión por crear velas aromáticas y wax melts artesanales."
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:url"
          content="https://lumieretica.com/sobre-nosotros"
        />

        <meta
          property="og:site_name"
          content="Lumière Tica"
        />

        <meta
          property="og:image"
          content="https://lumieretica.com/LumierTicaColeccion.jpeg"
        />

        <meta
          property="og:image:alt"
          content="Colección de velas artesanales de Lumière Tica"
        />
      </Helmet>

      <Header />

      <main>
        <section
          id="about"
          className="py-5"
          style={{
            backgroundColor: 'white',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          {/* Efecto decorativo de fondo */}
          <div
            style={{
              position: 'absolute',
              top: '-30%',
              right: '-10%',
              width: '50%',
              height: '100%',
              background:
                'radial-gradient(circle, rgba(212, 165, 116, 0.05) 0%, transparent 70%)',
              pointerEvents: 'none'
            }}
          />

          <div
            style={{
              position: 'absolute',
              bottom: '-20%',
              left: '-5%',
              width: '40%',
              height: '80%',
              background:
                'radial-gradient(circle, rgba(212, 165, 116, 0.03) 0%, transparent 70%)',
              pointerEvents: 'none'
            }}
          />

          <Container
            className="position-relative"
            style={{ zIndex: 1 }}
          >
            {/* Encabezado de sección */}
            <div className="text-center mb-5">
              <Badge
                bg="none"
                className="px-4 py-2 mb-3"
                style={{
                  backgroundColor: 'rgba(212, 165, 116, 0.15)',
                  color: '#d4a574',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  borderRadius: '50px'
                }}
              >
                Sobre Nosotros
              </Badge>

              <h1
                className="display-5 fw-bold mb-3"
                style={{
                  fontFamily: 'Georgia, serif',
                  color: '#1a1a1a',
                  letterSpacing: '2px'
                }}
              >
                Sobre Nosotros
              </h1>

              <p
                className="lead mb-3"
                style={{
                  fontFamily: 'Georgia, serif',
                  color: '#555'
                }}
              >
                Luz que abraza tus sentidos
              </p>

              <div
                style={{
                  width: '80px',
                  height: '3px',
                  backgroundColor: '#d4a574',
                  margin: '0 auto',
                  borderRadius: '2px'
                }}
              />
            </div>

            {/* Contenido principal */}
            <Row className="align-items-center g-5">
              {/* Columna izquierda - Imagen */}
              <Col lg={6}>
                <div
                  className="position-relative"
                  style={{
                    borderRadius: '16px',
                    overflow: 'hidden',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.08)'
                  }}
                >
                  <img
                    src="/LumierTicaColeccion.jpeg"
                    alt="Colección de velas artesanales de Lumière Tica"
                    style={{
                      width: '100%',
                      height: '400px',
                      objectFit: 'cover',
                      display: 'block'
                    }}
                  />

                  {/* Badge flotante */}
                  <div className="position-absolute bottom-0 start-0 m-4">
                    <div
                      className="px-4 py-3 rounded-3"
                      style={{
                        backgroundColor: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
                      }}
                    >
                      <span
                        className="d-block fw-bold"
                        style={{
                          fontFamily: 'Georgia, serif',
                          fontSize: '1.5rem',
                          color: '#d4a574'
                        }}
                      >
                        +50
                      </span>

                      <span
                        style={{
                          fontSize: '0.8rem',
                          color: '#666'
                        }}
                      >
                        Aromas Únicos
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              {/* Columna derecha - Texto */}
              <Col lg={6}>
                <div className="ps-lg-4">
                  <h2
                    className="mb-3"
                    style={{
                      fontFamily: 'Georgia, serif',
                      fontSize: '1.8rem',
                      color: '#1a1a1a',
                      letterSpacing: '1px'
                    }}
                  >
                    Nuestra Historia
                  </h2>

                  <p
                    style={{
                      fontSize: '1.05rem',
                      color: '#555',
                      lineHeight: '1.8',
                      marginBottom: '1.5rem'
                    }}
                  >
                    <strong style={{ color: '#d4a574' }}>
                      Lumière Tica
                    </strong>{' '}
                    nació con una idea sencilla: crear productos artesanales
                    que hicieran de los pequeños momentos algo especial.
                  </p>

                  <p
                    style={{
                      fontSize: '1.05rem',
                      color: '#555',
                      lineHeight: '1.8',
                      marginBottom: '2rem'
                    }}
                  >
                    Creemos que un aroma tiene el poder de despertar
                    recuerdos, transmitir tranquilidad y cambiar el ambiente
                    de un espacio. Por eso elaboramos cada vela y cada wax
                    melt con{' '}
                    <strong style={{ color: '#d4a574' }}>
                      cera de soya
                    </strong>{' '}
                    y fragancias cuidadosamente seleccionadas, prestando
                    atención a cada detalle del proceso.
                  </p>

                  <p
                    style={{
                      fontSize: '1.05rem',
                      color: '#555',
                      lineHeight: '1.8',
                      marginBottom: '2rem'
                    }}
                  >
                    Nuestro objetivo es ofrecer productos que acompañen tus
                    momentos de descanso, celebración o simplemente esos
                    instantes en los que deseas disfrutar de un ambiente
                    agradable.
                  </p>

                  <p
                    style={{
                      fontSize: '1.05rem',
                      color: '#555',
                      lineHeight: '1.8',
                      marginBottom: '2rem'
                    }}
                  >
                    Gracias por apoyar un emprendimiento hecho con dedicación
                    y por permitirnos formar parte de esos pequeños momentos
                    que hacen la diferencia.
                  </p>
                </div>
              </Col>
            </Row>

            {/* Sección de valores */}
            <Row className="mt-5 pt-4 g-4">
              <Col lg={4} md={6}>
                <div
                  className="text-center rounded-4 d-flex flex-column"
                  style={{
                    backgroundColor: '#f8f5f0',
                    height: '100%',
                    padding: '2rem 1.5rem'
                  }}
                >
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                    style={{
                      width: '70px',
                      height: '70px',
                      backgroundColor: 'rgba(212, 165, 116, 0.15)',
                      marginTop: '0.5rem'
                    }}
                  >
                    <i
                      className="fas fa-heart"
                      style={{
                        color: '#d4a574',
                        fontSize: '1.8rem'
                      }}
                    ></i>
                  </div>

                  <h3
                    className="fw-bold"
                    style={{
                      fontFamily: 'Georgia, serif',
                      color: '#1a1a1a',
                      letterSpacing: '1px'
                    }}
                  >
                    Hecho con Amor
                  </h3>

                  <p
                    style={{
                      color: '#666',
                      fontSize: '0.95rem',
                      lineHeight: '1.6'
                    }}
                  >
                    Cada vela es creada artesanalmente con dedicación y
                    pasión cuidando cada detalle para ofrecer una experiencia
                    única.
                  </p>
                </div>
              </Col>

              <Col lg={4} md={6}>
                <div
                  className="text-center rounded-4 d-flex flex-column"
                  style={{
                    backgroundColor: '#f8f5f0',
                    height: '100%',
                    padding: '2rem 1.5rem'
                  }}
                >
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                    style={{
                      width: '70px',
                      height: '70px',
                      backgroundColor: 'rgba(212, 165, 116, 0.15)',
                      marginTop: '0.5rem'
                    }}
                  >
                    <i
                      className="fas fa-leaf"
                      style={{
                        color: '#d4a574',
                        fontSize: '1.8rem'
                      }}
                    ></i>
                  </div>

                  <h3
                    className="fw-bold"
                    style={{
                      fontFamily: 'Georgia, serif',
                      color: '#1a1a1a',
                      letterSpacing: '1px'
                    }}
                  >
                    Compromiso Natural
                  </h3>

                  <p
                    style={{
                      color: '#666',
                      fontSize: '0.95rem',
                      lineHeight: '1.6'
                    }}
                  >
                    Usamos cera de soya para cuidar tu hogar y el planeta.
                  </p>
                </div>
              </Col>

              <Col lg={4} md={12}>
                <div
                  className="text-center rounded-4 d-flex flex-column"
                  style={{
                    backgroundColor: '#f8f5f0',
                    height: '100%',
                    padding: '2rem 1.5rem'
                  }}
                >
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
                    style={{
                      width: '70px',
                      height: '70px',
                      backgroundColor: 'rgba(212, 165, 116, 0.15)',
                      marginTop: '0.5rem'
                    }}
                  >
                    <i
                      className="fas fa-star"
                      style={{
                        color: '#d4a574',
                        fontSize: '1.8rem'
                      }}
                    ></i>
                  </div>

                  <h3
                    className="fw-bold"
                    style={{
                      fontFamily: 'Georgia, serif',
                      color: '#1a1a1a',
                      letterSpacing: '1px'
                    }}
                  >
                    Variedad y Estilo
                  </h3>

                  <p
                    style={{
                      color: '#666',
                      fontSize: '0.95rem',
                      lineHeight: '1.6'
                    }}
                  >
                    Contamos con una amplia variedad de diseños y fragancias,
                    pensados para adaptarse a diferentes gustos, ocasiones y
                    estilos.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default SobreNosotros;